import React, { useEffect, useState } from "react";
import classes from "./tdsPayables.module.css";
// import classes from "./tdsPaybles.module.css";
import axios from "../../../../axios-order";
import { Button, Grid, Drawer, Dialog, DialogContent, DialogTitle, DialogActions, TablePagination } from "@material-ui/core";
import AddTdsForm from "./add";
import EditTdsForm from "./edit";
import ReversalAddForm from "./reversalAdd";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import RightDrawer from "../../../../components/ui/RightDrawer";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from "react-router-dom";
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Card from "../../../../components/ui/Cards";
import tdsProvisionTemplate from "../../../../asserts/templates/TDS Provision.xlsx";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function Provision(props) {
  let history = useHistory();

  const [provisionMasterData, setProvisionMasterData] = useState([]);
  const [provisionMasterTblSerachData, setProvisionMasterTblSearchData] =
    useState([]);
  const [addFormDrawerOpen, setAddFormDrawerOpen] = useState(false);
  const [editFormDrawerOpen, setEditFormDrawerOpen] = useState(false);
  const [editData, setEditData] = useState({});

  const [createProvisionData, setCreateProvisionData] = useState([]);
  const [createProvisionTbSerachData, setCreateProvisonTbSearchData] = useState(
    []
  );
  const [reversalAddFormDrawerOpen, setReversalAddFormDrawerOpen] =
    useState(false);
  const [reversalTbData, setReversalTbData] = useState([]);
  const [reversalTbsearchData, setReversalTbSearchData] = useState([]);

  const [loaderForTableSummary, setLoaderForTableSummary] = useState(false);
  const [loaderForTableCreateProvision, setLoaderForTableCreateProvision] =
    useState(false);
  const [loaderForTableReversal, setLoaderForTableReversal] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isExportingProvisionReport, setIsExportingProvisionReport] = useState(false)
  const [uploadDrawerOpen, setUploadDrawerOpen] = useState(false);
  const [provisionUploadHistory, setProvisionUploadHistory] = useState([]);
  const [loaderForUploadHistory, setLoaderForUploadHistory] = useState(false);

  // provision upload log/report states
  const [showUploadReport, setShowUploadReport] = useState(false);
  const [uploadReportData, setUploadReportData] = useState(null);
  const [loaderForUploadReport, setLoaderForUploadReport] = useState(false);
  const [currentJsonId, setCurrentJsonId] = useState(null);
  const [reportPage, setReportPage] = useState(0);
  const [reportRowsPerPage, setReportRowsPerPage] = useState(10);
  const [reportTotal, setReportTotal] = useState(0);

  // reversal of provision upload states
  const [reversalUploadDrawerOpen, setReversalUploadDrawerOpen] = useState(false);
  const [reversalUploadHistory, setReversalUploadHistory] = useState([]);
  const [loaderForReversalUploadHistory, setLoaderForReversalUploadHistory] = useState(false);
  const [showReversalUploadReport, setShowReversalUploadReport] = useState(false);
  const [reversalUploadReportData, setReversalUploadReportData] = useState(null);
  const [loaderForReversalUploadReport, setLoaderForReversalUploadReport] = useState(false);
  const [currentReversalJsonId, setCurrentReversalJsonId] = useState(null);
  const [reversalReportPage, setReversalReportPage] = useState(0);
  const [reversalReportRowsPerPage, setReversalReportRowsPerPage] = useState(10);
  const [reversalReportTotal, setReversalReportTotal] = useState(0);
  const [isExportingReversalReport, setIsExportingReversalReport] = useState(false)

  // provision master(summary) table data
  const getProvisionMasterData = () => {
    setLoaderForTableSummary(true);
    axios
      .get(`/tds/provision/get/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        setProvisionMasterData(res.data.record);
        setProvisionMasterTblSearchData(res.data.record);
        setLoaderForTableSummary(false);
      })
      .catch((err) => {
        setLoaderForTableSummary(false);
      });
  };

  // create provision get api call
  const getCreateProvision = () => {
    setLoaderForTableCreateProvision(true);
    axios
      .get(
        `/tds/provision_vendor/get/${localStorage.getItem(
          "business_entity_id"
        )}`
      )
      .then((res) => {
        setLoaderForTableCreateProvision(false);
        setCreateProvisionData(res.data.record);
        setCreateProvisonTbSearchData(res.data.record);
      })
      .catch((err) => {
        setLoaderForTableCreateProvision(false);
      });
  };

  const handleBack = () => {
    history.push('/reconCards');
  };

  // reversal table data get api call
  const reversalTbGetApiCall = () => {
    setLoaderForTableReversal(true);
    axios
      .get(
        `/tds/provision_reversal/get/${localStorage.getItem(
          "business_entity_id"
        )}`
      )
      .then((res) => {
        setLoaderForTableReversal(false);
        setReversalTbData(res.data.record);
        setReversalTbSearchData(res.data.record);
      })
      .catch((err) => {
        setLoaderForTableReversal(false);
      });
  };

  const getProvisionUploadHistory = () => {
    setLoaderForUploadHistory(true);
    axios
      .get(
        `/get_tds_provision_upload_logs/${localStorage.getItem("business_entity_id")}`
      )
      .then((res) => {
        setProvisionUploadHistory(Array.isArray(res.data.records) ? res.data.records : []);
        setLoaderForUploadHistory(false);
      })
      .catch((err) => {
        console.log(err);
        setProvisionUploadHistory([]);
        setLoaderForUploadHistory(false);
      });
  };

  const tdsProvisionFileUploader = (event, uploadFor) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      axios
        .post(`/tds_provision_upload`, {
          business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
          document_name: file.name,
          file: reader.result,
          upload_for: uploadFor,
        })
        .then((res) => {
          if (uploadFor === "reversal") {
            getReversalUploadHistory();
          } else {
            getProvisionUploadHistory();
          }
          getProvisionMasterData();
          getCreateProvision();
          reversalTbGetApiCall();
        })
        .catch((err) => {
          console.log(err);
        });
    };
    reader.onerror = () => {
      console.log("Error reading file");
    };
    reader.readAsDataURL(file);
  };

  const viewProvisionUploadLog = (jsonId, page = 1, perPage = reportRowsPerPage) => {
    if (!jsonId) return;
    setCurrentJsonId(jsonId);
    setLoaderForUploadReport(true);
    setShowUploadReport(true);
    axios
      .get(`/get_tds_provision_upload_json/${jsonId}/${page}/${perPage}`)
      .then((res) => {
        setUploadReportData(res.data.records);
        setReportTotal(res.data.total || 0);
        setReportPage((res.data.page || page) - 1);
        setReportRowsPerPage(res.data.per_page || perPage);
        setLoaderForUploadReport(false);
      })
      .catch((err) => {
        console.log(err);
        setUploadReportData(null);
        setLoaderForUploadReport(false);
      });
  };

  const handleReportPageChange = (event, newPage) => {
    setReportPage(newPage);
    viewProvisionUploadLog(currentJsonId, newPage + 1, reportRowsPerPage);
  };

  const handleReportRowsPerPageChange = (event) => {
    const newPerPage = +event.target.value;
    setReportRowsPerPage(newPerPage);
    setReportPage(0);
    viewProvisionUploadLog(currentJsonId, 1, newPerPage);
  };

  const closeUploadReport = () => {
    setShowUploadReport(false);
    setUploadReportData(null);
    setCurrentJsonId(null);
  };

  // ...........................reversal of provision upload fns...........................

  const getReversalUploadHistory = () => {
    setLoaderForReversalUploadHistory(true);
    axios
      .get(
        `/get_tds_provision_reversal_upload_logs/${localStorage.getItem("business_entity_id")}`
      )
      .then((res) => {
        setReversalUploadHistory(Array.isArray(res.data.records) ? res.data.records : []);
        setLoaderForReversalUploadHistory(false);
      })
      .catch((err) => {
        console.log(err);
        setReversalUploadHistory([]);
        setLoaderForReversalUploadHistory(false);
      });
  };


  const viewReversalUploadLog = (jsonId, page = 1, perPage = reversalReportRowsPerPage) => {
    if (!jsonId) return;
    setCurrentReversalJsonId(jsonId);
    setLoaderForReversalUploadReport(true);
    setShowReversalUploadReport(true);
    axios
      .get(`/get_tds_provision_reversal_upload_json/${jsonId}/${page}/${perPage}`)
      .then((res) => {
        setReversalUploadReportData(res.data.records);
        setReversalReportTotal(res.data.total || 0);
        setReversalReportPage((res.data.page || page) - 1);
        setReversalReportRowsPerPage(res.data.per_page || perPage);
        setLoaderForReversalUploadReport(false);
      })
      .catch((err) => {
        console.log(err);
        setReversalUploadReportData(null);
        setLoaderForReversalUploadReport(false);
      });
  };

  const handleReversalReportPageChange = (event, newPage) => {
    setReversalReportPage(newPage);
    viewReversalUploadLog(currentReversalJsonId, newPage + 1, reversalReportRowsPerPage);
  };

  const handleReversalReportRowsPerPageChange = (event) => {
    const newPerPage = +event.target.value;
    setReversalReportRowsPerPage(newPerPage);
    setReversalReportPage(0);
    viewReversalUploadLog(currentReversalJsonId, 1, newPerPage);
  };

  const closeReversalUploadReport = () => {
    setShowReversalUploadReport(false);
    setReversalUploadReportData(null);
    setCurrentReversalJsonId(null);
  };

  const reversalUploadDrawerCloseHandler = () => {
    setReversalUploadDrawerOpen(false);
    closeReversalUploadReport();
    reversalTbGetApiCall();
    getProvisionMasterData();
  };

  const downloadProvisionTemplate = () => {
    const link = document.createElement("a");
    link.href = tdsProvisionTemplate;
    link.download = "TDS Provision.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportProvisionExcelReport = () => {
    setIsExportingProvisionReport(true);
    axios
      .get(
        `/generate_tds_provision_excel_report/${localStorage.getItem(
          "business_entity_id"
        )}`
      )
      .then((res) => {
        downloadBase64File(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          res.data.file,
          "tds_provision_report.xlsx"
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsExportingProvisionReport(false);
      });
  };

  const exportReversalExcelReport = () => {
    setIsExportingReversalReport(true);
    axios
      .get(
        `/generate_tds_provision_reversal_excel_report/${localStorage.getItem(
          "business_entity_id"
        )}`
      )
      .then((res) => {
        downloadBase64File(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          res.data.file,
          "tds_provision_reversal_report.xlsx"
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsExportingReversalReport(false);
      });
  };

  const uploadDrawerCloseHandler = () => {
    setUploadDrawerOpen(false);
    closeUploadReport();
    getProvisionMasterData();
    getCreateProvision();
  };

  useEffect(() => {
    getProvisionMasterData();
    getCreateProvision();

    reversalTbGetApiCall();
  }, []);

  // indian date format
  const indianFormatDate = (date) => {
    let dateArr = date.split("-");
    return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
  };

  const formatUploadDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // TDS Provision Summary table search
  const serachTdsSummary = (e) => {
    const search = e.target.value;
    const searchJson = provisionMasterTblSerachData.filter((v) => {
      return (
        String(v.pan).toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
        String(v.vendor_legal_name)
          .toLowerCase()
          .indexOf(search.toLowerCase()) >= 0
      );
    });
    setProvisionMasterData(searchJson);
  };

  // reversal table search
  const reversalTbSearch = (e) => {
    const search = e.target.value;
    const searchJson = reversalTbsearchData.filter((v) => {
      return (
        String(v.pan).toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
        String(v.vendor_legal_name)
          .toLowerCase()
          .indexOf(search.toLowerCase()) >= 0
      );
    });
    setReversalTbData(searchJson);
  };

  // create provison table serach
  const createProvisonTbSearch = (e) => {
    const search = e.target.value;
    const searchJson = createProvisionTbSerachData.filter((v) => {
      return (
        String(v.pan).toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
        String(v.vendor_legal_name)
          .toLowerCase()
          .indexOf(search.toLowerCase()) >= 0
      );
    });
    setCreateProvisionData(searchJson);
  };

  // indian rupeess system
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumSignificantDigits: 10,
    }).format(value);
  // ---End---

  // ......................................TDS Provision Summary table..................................
  const summaryTableBodyData = () => {
    if (loaderForTableSummary) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={11}
          >
            Loading…Please wait
          </td>
        </tr>
      );
    } else if (provisionMasterData && provisionMasterData.length > 0) {
      return provisionMasterData.map((item, i) => {
        return (
          <tr key={i}>
            <td>{item.vendor_legal_name}</td>
            <td>{item.pan}</td>
            <td>
              {item.provision_create_date &&
                indianFormatDate(item.provision_create_date)}
            </td>
            <td>{numberFormat(item.provision_amount)}</td>
            <td>{numberFormat(item.provision_tds)} </td>
            <td>{item.booking_date && indianFormatDate(item.booking_date)} </td>
            <td>{item.bill_number} </td>
            <td>{numberFormat(item.reversel_provision_amount)} </td>
            <td>{numberFormat(item.reversel_provision_tds)} </td>
            {item.balance_provision_amount < 0 ? (
              <td style={{ color: "red" }}>
                {numberFormat(item.balance_provision_amount)}{" "}
              </td>
            ) : (
              <td>{numberFormat(item.balance_provision_amount)} </td>
            )}
            {item.balance_provision_tds < 0 ? (
              <td style={{ color: "red" }}>
                {numberFormat(item.balance_provision_tds)}{" "}
              </td>
            ) : (
              <td>{numberFormat(item.balance_provision_tds)} </td>
            )}
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ textAlign: "center", color: "red" }} colSpan={11}>
            No Data Found!
          </td>
        </tr>
      );
    }
  };

  // ........................................create provision table all event...........................................

  const createProvisionTableBodyData = () => {
    if (loaderForTableCreateProvision) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={8}
          >
            Loading…Please wait
          </td>
        </tr>
      );
    } else if (createProvisionData.length > 0) {
      return createProvisionData.map((item, i) => {
        return (
          <tr key={i}>
            <td>{item.vendor_legal_name}</td>
            <td>{item.pan}</td>
            <td>
              {item.provision_create_date
                ? indianFormatDate(item.provision_create_date)
                : ""}
            </td>
            <td>{numberFormat(item.amount)}</td>
            <td>{item.tds_section}</td>
             <td>{item.section_new}</td>
            <td>{item.tds_percentage}%</td>
            <td>{numberFormat(item.tds_payable)}</td>
            <td>
              {/* <span>
                <EditOutlinedIcon
                  className="action-icon-button editIcon"
                  style={{ cursor: "pointer" }}
                  onClick={() => editFormOpenDrawerHandler(item)}
                />
              </span>{" "}
              |{" "} */}
              <span>
                <DeleteForeverOutlinedIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => deleteTableRow(item.id)}
                  className="action-icon-button deleteIcon"
                />
              </span>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ textAlign: "center", color: "red" }} colSpan={8}>
            No Data Found!
          </td>
        </tr>
      );
    }
  };
  // .......close add form drawer.....
  const addFormCloseDrawerHandler = () => {
    setAddFormDrawerOpen(false);
  };
  // ........open edit form drawer.....
  const editFormOpenDrawerHandler = (item) => {
    setEditFormDrawerOpen(true);
    setEditData(item);
  };
  // .......close edit form drawer.....
  const editFormCloseDrawerHandler = () => {
    setEditFormDrawerOpen(false);
  };

  // ........delete table row.........
  const deleteTableRow = (id) => {
    let text = "Are you sure! you want to delete this record.";
    if (window.confirm(text) === true) {
      axios
        .delete(`/tds/provision_vendor/delete/${id}`)
        .then((res) => {
          getProvisionMasterData();
          getCreateProvision();
          reversalTbGetApiCall();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
    }
  };

  // close reversal add form drawer
  const reversalAddFormCloseDrawerHandler = () => {
    setReversalAddFormDrawerOpen(false);
  };

  const deleteReversalTableRow = (id) => {
    let text = "Are you sure! you want to delete this record.";
    if (window.confirm(text) === true) {
      axios
        .delete(`/tds/provision/delete/${id}`)
        .then((res) => {
          getProvisionMasterData();
          reversalTbGetApiCall();
          getCreateProvision();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
    }
  };

  const reversalProvisionTableBodyData = () => {
    if (loaderForTableReversal) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={9}
          >
            Loading…Please wait
          </td>
        </tr>
      );
    } else if (reversalTbData && reversalTbData.length > 0) {
      return reversalTbData.map((item, i) => {
        return (
          <tr key={i}>
            <td>{item.vendor_legal_name}</td>
            <td>{item.pan}</td>
            <td>{item.bill_number} </td>
            <td>{item.booking_date && indianFormatDate(item.booking_date)}</td>
            <td>{numberFormat(item.reversel_provision_amount)}</td>
            <td>{item.tds_section}</td>
            <td>{item.tds_percentage}</td>
            <td>{numberFormat(item.reversel_provision_tds)}</td>
            <td>
              <DeleteForeverOutlinedIcon
                style={{ cursor: "pointer" }}
                onClick={() => deleteReversalTableRow(item.id)}
                className="action-icon-button deleteIcon"
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ textAlign: "center", color: "red" }} colSpan={9}>
            No Data Found!
          </td>
        </tr>
      );
    }
  };
  // ...........................................reversal provision table event end .............................................
  //excel download
  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const exportToExcelFinalData = {
    business_entity_id: localStorage.getItem("business_entity_id"),
    summary: provisionMasterData,
    create_provision: createProvisionData,
    reversal_provision: reversalTbData,
  };

  const exportToExcel = () => {
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `tds_provision_summary.xlsx`;

    axios
      .post("/tds/provision/summary/download", {
        data: exportToExcelFinalData,
      })
      .then((res) => {
        downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={handleBack}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
      </div>

      {/* ...........tds summary table........ */}
      <BoxWrapper
        boxTitle="TDS Provision Summary"
        // export to excel
        exportToExcelEnable={true}
        exportToExcelFn={exportToExcel}
        // search input
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={serachTdsSummary}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <tbody>
              <tr>
                <th>Vendor Name</th>
                <th>PAN</th>
                <th>Provision Created date*</th>
                <th>Provision Amount</th>
                <th>Provision TDS</th>
                <th>Booking Date (Reversal Date)</th>
                <th>Bill No</th>
                <th>Reversal of Provision Amount</th>
                <th>Reversal of Provision TDS</th>
                <th>Balance Provision Amount</th>
                <th>Balance Provision TDS</th>
              </tr>
              {summaryTableBodyData()}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {/* ...........create provision table........ */}

      <BoxWrapper
        boxTitle={
          <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            Provision
           
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: "#03406d",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: 600,
                  padding: "4px 14px",
                  minWidth: "auto",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  setUploadDrawerOpen(true);
                  getProvisionUploadHistory();
                }}
              >
                Upload
              </Button>
            <Button
              variant="outlined"
              size="small"
              style={{
                color: "#03406d",
                borderColor: "#03406d",
                fontSize: "14px",
                fontWeight: 600,
                padding: "4px 14px",
                minWidth: "auto",
                textTransform: "uppercase",
              }}
              onClick={exportProvisionExcelReport}
              disabled={isExportingProvisionReport}
            >
              <GetAppIcon style={{ fontSize: "18px", marginRight: "4px" }} />
              {isExportingProvisionReport ? "EXPORTING…" : "EXPORT"}
            </Button>
          </span>
        }
        // search input
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={createProvisonTbSearch}
        // add button
        enableAddButton={true}
        addButtonLabel="Create"
        addButtonHandlerFn={() => setAddFormDrawerOpen(true)}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <tbody>
              <tr>
                <th style={{ width: "200px" }}>Vendor Name</th>
                <th>PAN</th>
                <th>Provision Created date</th>
                <th>Amount</th>
                <th>TDS Section</th>
                <th>New Section</th>
                <th>TDS %</th>
                <th>TDS Payable</th>
                <th>Action</th>
              </tr>
              {createProvisionTableBodyData()}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {/* .........provision second table ....... */}
      <BoxWrapper
        boxTitle={
          <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            Reversal of Provision
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: "#03406d",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: 600,
                  padding: "4px 14px",
                  minWidth: "auto",
                  textTransform: "uppercase",
                }}
                onClick={() => {
                  setReversalUploadDrawerOpen(true);
                  getReversalUploadHistory();
                }}
              >
                Upload
              </Button>
          </span>
        }
        // search input
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={reversalTbSearch}
        // add button
        enableAddButton={true}
        addButtonLabel="Date of Reversal"
        addButtonHandlerFn={() => setReversalAddFormDrawerOpen(true)}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <tbody>
              <tr>
                <th>Vendor Name</th>
                <th>PAN</th>
                <th>Bill No</th>
                <th>Booking Date (Reversal Date)</th>
                <th>Taxable + Non Taxable Amount (excluding GST/CESS)</th>
                <th>TDS Section</th>
                <th>TDS %</th>
                <th>TDS Payable</th>
                <th>Action</th>
              </tr>
              {reversalProvisionTableBodyData()}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {/* ........add tds form drawer.......... */}
      <RightDrawer
        drawerName="Create provision"
        open={addFormDrawerOpen}
        onClose={addFormCloseDrawerHandler}
        variant={"persistent"}
      >
        <AddTdsForm
          cancelAddForm={addFormCloseDrawerHandler}
          updateTable={getCreateProvision}
          updateMasterTable={getProvisionMasterData}
          updateReversalOfProvision={reversalTbGetApiCall}
        />
      </RightDrawer>
      {/* ........edit tds form drawer...... */}
      <RightDrawer
        drawerName="Edit provision"
        open={editFormDrawerOpen}
        onClose={editFormCloseDrawerHandler}
      >
        <EditTdsForm
          cancelEditForm={editFormCloseDrawerHandler}
          editFormData={editData}
          updateTable={getCreateProvision}
          updateMasterTable={getProvisionMasterData}
          updateReversalOfProvision={reversalTbGetApiCall}
        />
      </RightDrawer>

      {/* ..........add reversal of provision....... */}
      <RightDrawer
        drawerName="Date of Reversal"
        open={reversalAddFormDrawerOpen}
        onClose={reversalAddFormCloseDrawerHandler}
        variant={"persistent"}
      >
        <ReversalAddForm
          cancelAddForm={reversalAddFormCloseDrawerHandler}
          // createProvisionData={createProvisionData}
          updateTableAfterSubmit={reversalTbGetApiCall}
          updateMasterTable={getProvisionMasterData}
          updateTable={getCreateProvision}
        />
      </RightDrawer>

      {/* ..........provision upload card....... */}
      <Dialog
        open={uploadDrawerOpen}
        onClose={uploadDrawerCloseHandler}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#03406d",
            color: "#ffffff",
            padding: "14px 24px",
          }}
        >
          <span style={{ fontWeight: 700, fontSize: "18px" }}>Provision Upload</span>
        </DialogTitle>
        <DialogContent style={{ paddingTop: "20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
            <div>
              <Button component="label" size="small" color="primary" onClick={downloadProvisionTemplate}>
                <GetAppIcon style={{ fontSize: "20px" }} />
                DOWNLOAD TEMPLATE
              </Button>
              <Button component="label" size="small" color="primary">
                <PublishIcon style={{ fontSize: "20px" }} />
                UPLOAD TEMPLATE
                <input
                  accept=".xlsx"
                  name="file"
                  type="file"
                  value=""
                  hidden
                  onChange={(e) => tdsProvisionFileUploader(e, "provision")}
                />
              </Button>
            </div>
            <div>
              <Button component="label" size="small" color="primary" onClick={getProvisionUploadHistory}>
                <RefreshIcon style={{ fontSize: "20px" }} />
                Refresh
              </Button>
            </div>
          </div>

          <div className="responsive-table">
            <table className="custome-table">
              <thead>
                <tr>
                  <th>Last Upload Date & Time</th>
                  <th>Status</th>
                  <th>Upload Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loaderForUploadHistory ? (
                  <tr>
                    <td style={{ color: "black", textAlign: "center", fontWeight: "bold" }} colSpan={4}>
                      Loading…Please wait
                    </td>
                  </tr>
                ) : provisionUploadHistory.length > 0 ? (
                  provisionUploadHistory.map((item, i) => (
                    <tr key={i}>
                      <td>{formatUploadDateTime(item.created_date)}</td>
                      <td>{item.status}</td>
                      <td>{item.upload_type || "-"}</td>
                      <td>
                        {["Pass", "Fail"].includes(item.status) ? (
                          <RemoveRedEyeOutlinedIcon
                            className="action-icon-button showIcon"
                            style={{ cursor: "pointer" }}
                            onClick={() => viewProvisionUploadLog(item.id, 1, reportRowsPerPage)}
                          />
                        ) : (
                          <RemoveRedEyeOutlinedIcon
                            style={{ color: "#c0c0c0", cursor: "not-allowed" }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={{ textAlign: "center", color: "red" }} colSpan={4}>
                      No Data Found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ..........upload log/report section.......... */}
          {showUploadReport && (
            <div style={{ marginTop: "25px", borderTop: "1px solid #e0e0e0", paddingTop: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <span style={{ fontWeight: 700, color: "#03406d" }}>Upload Details</span>
                <IconButton size="small" onClick={closeUploadReport}>
                  <CloseIcon />
                </IconButton>
              </div>

              {loaderForUploadReport ? (
                <div style={{ textAlign: "center", fontWeight: "bold" }}>Loading…Please wait</div>
              ) : uploadReportData?.message ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "12px",
                    backgroundColor: "#fdecea",
                    border: "1px solid #f5c2c0",
                    borderRadius: "6px",
                    padding: "16px 18px",
                  }}
                >
                  <ErrorOutlineIcon style={{ color: "#eb596e", fontSize: "22px", marginTop: "1px" }} />
                  <div>
                    <div style={{ fontWeight: 700, color: "#a12b3a", fontSize: "14px", marginBottom: "2px" }}>
                      Upload Failed
                    </div>
                    <div style={{ color: "#7a1f2b", fontSize: "13.5px" }}>
                      {uploadReportData.message}
                    </div>
                  </div>
                </div>
              ) : uploadReportData ? (
                <>
                  <Grid container spacing={3} style={{ marginBottom: "15px" }}>
                    <Grid item sm={4}>
                      <Card
                        backgroundcolor="#6f9eaf"
                        cardTitle="Total Records"
                        cardBody={uploadReportData.summary?.total_records ?? 0}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <Card
                        backgroundcolor="#007965"
                        cardTitle="Successful Records"
                        cardBody={uploadReportData.summary?.valid_records ?? 0}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <Card
                        backgroundcolor="#eb596e"
                        cardTitle="Error Records"
                        cardBody={uploadReportData.summary?.invalid_records ?? 0}
                      />
                    </Grid>
                  </Grid>

                  <div className="responsive-table">
                    <table className="custome-table">
                      <thead>
                        <tr>
                          <th>Row #</th>
                          <th>Status</th>
                          <th>Error</th>
                        </tr>
                      </thead>
                      <tbody>
                        {uploadReportData.details &&
                          uploadReportData.details.filter((item) => item.status === "Fail").length > 0 ? (
                          uploadReportData.details
                            .filter((item) => item.status === "Fail")
                            .map((item, i) => (
                              <tr key={i}>
                                <td>{item.row}</td>
                                <td>{item.status}</td>
                                <td style={{ color: "red" }}>
                                  {item.errors_in &&
                                    Object.keys(item.errors_in).map((key, k) => (
                                      <div key={k}>
                                        <span style={{ color: "black" }}>{key}</span>:{" "}
                                        {item.errors_in[key].join(", ")}
                                      </div>
                                    ))}
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={3} style={{ textAlign: "center", color: "green" }}>
                              No Errors Found!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {uploadReportData.details &&
                    uploadReportData.details.filter((item) => item.status === "Fail").length > 0 && (
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={reportTotal}
                        rowsPerPage={reportRowsPerPage}
                        page={reportPage}
                        onPageChange={handleReportPageChange}
                        onRowsPerPageChange={handleReportRowsPerPageChange}
                      />
                    )}
                </>
              ) : (
                <div style={{ textAlign: "center", color: "red" }}>No Data Found!</div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button
            variant="outlined"
            size="small"
            style={{ color: "#03406d", borderColor: "#03406d" }}
            onClick={uploadDrawerCloseHandler}
          >
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>

      {/* ..........reversal of provision upload card....... */}
      <Dialog
        open={reversalUploadDrawerOpen}
        onClose={reversalUploadDrawerCloseHandler}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#03406d",
            color: "#ffffff",
            padding: "14px 24px",
          }}
        >
          <span style={{ fontWeight: 700, fontSize: "18px" }}>Reversal of Provision Upload</span>
        </DialogTitle>
        <DialogContent style={{ paddingTop: "20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
            <div>
              <Button component="label" size="small" color="primary">
                <PublishIcon style={{ fontSize: "20px" }} />
                UPLOAD TEMPLATE
                <input
                  accept=".xlsx"
                  name="file"
                  type="file"
                  value=""
                  hidden
                  onChange={(e) => tdsProvisionFileUploader(e, "reversal")}
                />
              </Button>
            </div>
            <div>
              <Button
                component="label"
                size="small"
                color="primary"
                onClick={exportReversalExcelReport}
                disabled={isExportingReversalReport}
              >
                <GetAppIcon style={{ fontSize: "20px" }} />
                {isExportingReversalReport ? "EXPORTING…" : "EXPORT"}
              </Button>
              <Button component="label" size="small" color="primary" onClick={getReversalUploadHistory}>
                <RefreshIcon style={{ fontSize: "20px" }} />
                Refresh
              </Button>
            </div>
          </div>

          <div className="responsive-table">
            <table className="custome-table">
              <thead>
                <tr>
                  <th>Last Upload Date & Time</th>
                  <th>Status</th>
                  <th>Upload Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loaderForReversalUploadHistory ? (
                  <tr>
                    <td style={{ color: "black", textAlign: "center", fontWeight: "bold" }} colSpan={4}>
                      Loading…Please wait
                    </td>
                  </tr>
                ) : reversalUploadHistory.length > 0 ? (
                  reversalUploadHistory.map((item, i) => (
                    <tr key={i}>
                      <td>{formatUploadDateTime(item.created_date)}</td>
                      <td>{item.status}</td>
                      <td>{item.upload_type || "-"}</td>
                      <td>
                        {["Pass", "Fail"].includes(item.status) ? (
                          <RemoveRedEyeOutlinedIcon
                            className="action-icon-button showIcon"
                            style={{ cursor: "pointer" }}
                            onClick={() => viewReversalUploadLog(item.id, 1, reversalReportRowsPerPage)}
                          />
                        ) : (
                          <RemoveRedEyeOutlinedIcon
                            style={{ color: "#c0c0c0", cursor: "not-allowed" }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={{ textAlign: "center", color: "red" }} colSpan={4}>
                      No Data Found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ..........reversal upload log/report section.......... */}
          {showReversalUploadReport && (
            <div style={{ marginTop: "25px", borderTop: "1px solid #e0e0e0", paddingTop: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <span style={{ fontWeight: 700, color: "#03406d" }}>Upload Details</span>
                <IconButton size="small" onClick={closeReversalUploadReport}>
                  <CloseIcon />
                </IconButton>
              </div>

              {loaderForReversalUploadReport ? (
                <div style={{ textAlign: "center", fontWeight: "bold" }}>Loading…Please wait</div>
              ) : reversalUploadReportData?.message ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "12px",
                    backgroundColor: "#fdecea",
                    border: "1px solid #f5c2c0",
                    borderRadius: "6px",
                    padding: "16px 18px",
                  }}
                >
                  <ErrorOutlineIcon style={{ color: "#eb596e", fontSize: "22px", marginTop: "1px" }} />
                  <div>
                    <div style={{ fontWeight: 700, color: "#a12b3a", fontSize: "14px", marginBottom: "2px" }}>
                      Upload Failed
                    </div>
                    <div style={{ color: "#7a1f2b", fontSize: "13.5px" }}>
                      {reversalUploadReportData.message}
                    </div>
                  </div>
                </div>
              ) : reversalUploadReportData ? (
                <>
                  <Grid container spacing={3} style={{ marginBottom: "15px" }}>
                    <Grid item sm={4}>
                      <Card
                        backgroundcolor="#6f9eaf"
                        cardTitle="Total Records"
                        cardBody={reversalUploadReportData.summary?.total_records ?? 0}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <Card
                        backgroundcolor="#007965"
                        cardTitle="Successful Records"
                        cardBody={reversalUploadReportData.summary?.valid_records ?? 0}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <Card
                        backgroundcolor="#eb596e"
                        cardTitle="Error Records"
                        cardBody={reversalUploadReportData.summary?.invalid_records ?? 0}
                      />
                    </Grid>
                  </Grid>

                  <div className="responsive-table">
                    <table className="custome-table">
                      <thead>
                        <tr>
                          <th>Row #</th>
                          <th>Status</th>
                          <th>Error</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reversalUploadReportData.details &&
                          reversalUploadReportData.details.filter((item) => item.status === "Fail").length > 0 ? (
                          reversalUploadReportData.details
                            .filter((item) => item.status === "Fail")
                            .map((item, i) => (
                              <tr key={i}>
                                <td>{item.row}</td>
                                <td>{item.status}</td>
                                <td style={{ color: "red" }}>
                                  {item.errors_in &&
                                    Object.keys(item.errors_in).map((key, k) => (
                                      <div key={k}>
                                        <span style={{ color: "black" }}>{key}</span>:{" "}
                                        {item.errors_in[key].join(", ")}
                                      </div>
                                    ))}
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={3} style={{ textAlign: "center", color: "green" }}>
                              No Errors Found!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {reversalUploadReportData.details &&
                    reversalUploadReportData.details.filter((item) => item.status === "Fail").length > 0 && (
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={reversalReportTotal}
                        rowsPerPage={reversalReportRowsPerPage}
                        page={reversalReportPage}
                        onPageChange={handleReversalReportPageChange}
                        onRowsPerPageChange={handleReversalReportRowsPerPageChange}
                      />
                    )}
                </>
              ) : (
                <div style={{ textAlign: "center", color: "red" }}>No Data Found!</div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button
            variant="outlined"
            size="small"
            style={{ color: "#03406d", borderColor: "#03406d" }}
            onClick={reversalUploadDrawerCloseHandler}
          >
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
